import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class ArchiveIncomingApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'archiveIncoming'
  }

  /**
   * 查询四种状态收文数据
   * @param CurrentPageIndex
   * @param PageSize
   * @param params
   */
  public getListByParams(CurrentPageIndex, PageSize, params) {
    return this.send(params, "getListByParams?CurrentPageIndex=" + CurrentPageIndex + "&PageSize=" + PageSize, this.Methods.GET)
  }

  /**
     * 导出
     * @returns 
     */
  public excel(params) {
    return this.download(params, "excel")
  }

}